import { fromBuffer } from 'file-type';

import { FILE_EXTENSION_BLACK_LIST } from '@app/constants/file';
import getExtensionFromFileName from '@app/libs/file/getExtensionFromFileName';

const extMap: { [ext: string]: string[] } = {
  cfb: ['.hwp', '.doc', '.ppt', '.xls'],
  docx: ['.docx'],
  xlsx: ['.xlsx'],
  pptx: ['.pptx'],
  pdf: ['.pdf'],
  jpg: ['.jpg', '.jpeg'],
  jpeg: ['.jpg', '.jpeg'],
  png: ['.png'],
  gif: ['.gif'],
  bmp: ['.bmp'],
  tif: ['.tiff'],
};

export async function validateDocumentFile(file: File): Promise<boolean> {
  const arrayBuffer = await file.arrayBuffer();
  const result = await fromBuffer(arrayBuffer);

  if (
    result?.ext &&
    Object.keys(extMap).includes(result.ext) &&
    extMap[result.ext].includes(getExtensionFromFileName(file.name))
  ) {
    return true;
  }

  return false;
}

export async function validateAttachmentFile(file: File): Promise<boolean> {
  const arrayBuffer = await file.arrayBuffer();
  const result = await fromBuffer(arrayBuffer);
  let extension = '';

  if (!result || Object.keys(extMap).includes(result.ext)) {
    extension = getExtensionFromFileName(file.name);
  } else {
    extension = `.${result.ext}`;
  }

  const set = new Set(FILE_EXTENSION_BLACK_LIST);
  return !(extension && set.has(extension));
}
